var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useCallback } from 'react';
import classNames from 'classnames';
var FontAwesome = require('../../templates/FontAwesome');
var moduleStyles = require('./preview-controls.module.scss').default;
/**
 * Set of controls for previewing sounds in various custom Music Lab block fields
 */
var PreviewControls = function (props) { return (React.createElement("div", { className: moduleStyles.controlsRow },
    React.createElement(PreviewButton, __assign({}, props)),
    React.createElement(ClearButton, __assign({}, props)))); };
var ClearButton = function (_a) {
    var onClickClear = _a.onClickClear, cancelPreviews = _a.cancelPreviews;
    var onClick = useCallback(function () {
        cancelPreviews();
        onClickClear();
    }, [cancelPreviews, onClickClear]);
    return (React.createElement("button", { className: moduleStyles.buttonContainer, onClick: onClick, type: "button" },
        React.createElement(FontAwesome, { icon: 'trash-o', className: moduleStyles.previewButton })));
};
var PreviewButton = function (_a) {
    var enabled = _a.enabled, playPreview = _a.playPreview;
    return (React.createElement("button", { className: moduleStyles.buttonContainer, onClick: enabled ? playPreview : undefined, type: "button" },
        React.createElement(FontAwesome, { icon: 'play-circle', className: classNames(moduleStyles.previewButton, !enabled && moduleStyles.previewButtonDisabled) })));
};
export default PreviewControls;
